import React, { useRef, useState, useEffect } from 'react';

var SkeletonContainer = function SkeletonContainer(_ref) {
  var children = _ref.children,
      skeletonContainer = _ref.skeletonContainer,
      placeholder = _ref.placeholder,
      styleContainers = _ref.styleContainers;
  return React.createElement("div", {
    "data-testid": "skeleton-container",
    ref: skeletonContainer,
    style: styleContainers,
    className: "skeleton-container"
  }, placeholder, children);
};

var SkeletonWrapper = function SkeletonWrapper(_ref) {
  var children = _ref.children,
      placeholder = _ref.placeholder,
      styleContainers = _ref.styleContainers;
  return React.createElement("div", {
    "data-testid": "skeleton-wrapper",
    style: styleContainers,
    className: "skeleton-wrapper"
  }, placeholder, children);
};

var SkeletonTable = function SkeletonTable(_ref) {
  var tableRows = _ref.tableRows,
      tableColumns = _ref.tableColumns,
      styleTable = _ref.styleTable,
      styleCell = _ref.styleCell;
  return React.createElement("table", {
    "data-testid": "skeleton-table",
    style: styleTable,
    className: "skeleton-table"
  }, React.createElement("tbody", {
    style: {
      display: 'block'
    }
  }, tableRows.map(function (row) {
    return React.createElement("tr", {
      key: row,
      style: {
        display: 'block'
      }
    }, tableColumns.map(function (column) {
      return React.createElement("td", {
        key: column,
        style: styleCell
      });
    }));
  })));
};

var SkeletonAnimation = function SkeletonAnimation(_ref) {
  var styleAnimation = _ref.styleAnimation;
  return React.createElement("div", {
    "data-testid": "skeleton-animation",
    style: styleAnimation,
    className: "skeleton-animation"
  });
};

var SkeletonRender = function SkeletonRender(_ref) {
  var count = _ref.count,
      wrappers = _ref.wrappers,
      rows = _ref.rows,
      tableRows = _ref.tableRows,
      columns = _ref.columns,
      tableColumns = _ref.tableColumns,
      skeletonContainer = _ref.skeletonContainer,
      placeholder = _ref.placeholder,
      styleContainers = _ref.styleContainers,
      styleTable = _ref.styleTable,
      styleCell = _ref.styleCell,
      styleAnimation = _ref.styleAnimation,
      animation = _ref.animation;

  // renders the amount of wrappers received in the prop count
  if (count > 0) {
    return React.createElement(SkeletonContainer, {
      skeletonContainer: skeletonContainer,
      styleContainers: (styleContainers == null ? void 0 : styleContainers.cursor) && {
        cursor: 'progress'
      }
    }, wrappers.map(function (wrapper) {
      return React.createElement(SkeletonWrapper, {
        key: wrapper,
        styleContainers: styleContainers,
        placeholder: placeholder
      }, animation && React.createElement(SkeletonAnimation, {
        styleAnimation: styleAnimation
      }));
    }));
  } // renders the table if rows and columns are greater than 0


  if (rows > 0 && columns > 0) {
    return React.createElement(SkeletonContainer, {
      styleContainers: {
        position: 'relative'
      }
    }, React.createElement(SkeletonTable, {
      tableRows: tableRows,
      tableColumns: tableColumns,
      styleTable: styleTable,
      styleCell: styleCell
    }), animation && React.createElement(SkeletonAnimation, {
      styleAnimation: styleAnimation
    }));
  } // if it doesn't have wrappers or tables, render only the container


  return React.createElement(SkeletonContainer, {
    skeletonContainer: skeletonContainer,
    styleContainers: styleContainers,
    placeholder: placeholder
  }, animation && React.createElement(SkeletonAnimation, {
    styleAnimation: styleAnimation
  }));
};

var useResponsiveImages = function useResponsiveImages(responsiveImage, responsiveImageSSR) {
  var skeletonContainer = useRef(null);

  var _useState = useState(0),
      widthSkeletonContainer = _useState[0],
      setWidthSkeletonContainer = _useState[1];

  var _useState2 = useState(0),
      widthScreen = _useState2[0],
      setWidthScreen = _useState2[1];

  var _useState3 = useState(0),
      srcWidth = _useState3[0],
      setSrcWidth = _useState3[1];

  var _useState4 = useState(0),
      srcHeight = _useState4[0],
      setSrcHeight = _useState4[1];

  var getWidths = function getWidths() {
    if (skeletonContainer.current) {
      setWidthSkeletonContainer(skeletonContainer.current.offsetWidth);
      setWidthScreen(window.innerWidth);
    }
  };

  var SortByBreakIn = function SortByBreakIn(responsiveImageArray) {
    responsiveImageArray.sort(function (a, b) {
      if (a.breakIn && b.breakIn) {
        return a.breakIn > b.breakIn ? 1 : -1;
      } else if (!a.breakIn && b.breakIn) {
        return 1;
      } else if (a.breakIn && !b.breakIn) {
        return -1;
      }

      return a.srcWidth > b.srcWidth ? 1 : -1;
    });
  };

  var SortByWidth = function SortByWidth(responsiveImageArray) {
    responsiveImageArray.sort(function (a, b) {
      if (a.breakIn && b.breakIn && a.breakIn === b.breakIn) {
        return a.srcWidth > b.srcWidth ? 1 : -1;
      }

      return 0;
    });
  };

  useEffect(function () {
    !responsiveImageSSR && responsiveImage && window.addEventListener('resize', function () {
      return getWidths();
    });
    return function () {
      return window.removeEventListener('resize', function () {
        return getWidths();
      });
    };
  }, [responsiveImage, responsiveImageSSR]);
  useEffect(function () {
    if (responsiveImage && !responsiveImageSSR) {
      getWidths();

      if (!Array.isArray(responsiveImage)) {
        setSrcWidth(responsiveImage.srcWidth);
        setSrcHeight(responsiveImage.srcHeight);
      } else {
        SortByBreakIn(responsiveImage);
        SortByWidth(responsiveImage);
        setSrcWidth(responsiveImage[0].srcWidth);
        setSrcHeight(responsiveImage[0].srcHeight);
      }
    }
  }, [skeletonContainer, responsiveImage, responsiveImageSSR]); // determines which srcWidth and srcHeight should currently be used

  useEffect(function () {
    if (!responsiveImageSSR && responsiveImage && Array.isArray(responsiveImage) && responsiveImage[0].breakIn) {
      for (var i in responsiveImage) {
        var _responsiveImage$i;

        if (responsiveImage[0].breakIn >= widthScreen) {
          setSrcWidth(responsiveImage[0].srcWidth);
          setSrcHeight(responsiveImage[0].srcHeight);
        }

        if (((_responsiveImage$i = responsiveImage[i]) == null ? void 0 : _responsiveImage$i.breakIn) <= widthScreen && responsiveImage[+i + 1]) {
          setSrcWidth(responsiveImage[+i + 1].srcWidth);
          setSrcHeight(responsiveImage[+i + 1].srcHeight);
        }
      }
    }
  }, [widthScreen, responsiveImage, responsiveImageSSR]);
  return {
    srcWidth: srcWidth,
    srcHeight: srcHeight,
    widthSkeletonContainer: widthSkeletonContainer,
    skeletonContainer: skeletonContainer
  };
};

var createStyleContainers = function createStyleContainers(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      padding = _ref.padding,
      border = _ref.border,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      circle = _ref.circle,
      backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      cursor = _ref.cursor,
      placeholderPosition = _ref.placeholderPosition,
      justifyContent = _ref.justifyContent,
      alignItems = _ref.alignItems,
      animation = _ref.animation,
      count = _ref.count,
      responsiveImage = _ref.responsiveImage,
      responsiveImageSSR = _ref.responsiveImageSSR,
      widthSkeletonContainer = _ref.widthSkeletonContainer,
      srcWidth = _ref.srcWidth,
      srcHeight = _ref.srcHeight;
  var marginContainer = count > 0 ? '0 0 5px 0' : undefined;
  var borderRadiusContainer = circle ? '50%' : undefined;
  var responsiveImageHeight = responsiveImage ? srcWidth && srcHeight && widthSkeletonContainer * srcHeight / srcWidth : height;
  var definitiveHeight = responsiveImageSSR ? undefined : responsiveImageHeight;
  var paddingTop = responsiveImageSSR ? responsiveImageSSR.srcHeight * 100 / responsiveImageSSR.srcWidth + "%" : undefined;
  return {
    position: animation ? 'relative' : undefined,
    width: width,
    height: definitiveHeight,
    margin: margin ? margin : marginContainer,
    padding: padding,
    paddingTop: paddingTop,
    border: border ? '1px solid' : undefined,
    borderColor: border && (borderColor != null ? borderColor : '#000'),
    borderRadius: borderRadius ? borderRadius : borderRadiusContainer,
    backgroundColor: backgroundColor,
    color: color,
    cursor: cursor ? 'progress' : undefined,
    display: placeholderPosition ? 'flex' : undefined,
    justifyContent: justifyContent,
    alignItems: alignItems
  };
};

var createStyleTable = function createStyleTable(_ref) {
  var width = _ref.width,
      animation = _ref.animation,
      cursor = _ref.cursor;
  return {
    display: 'block',
    width: width,
    position: animation ? 'relative' : undefined,
    cursor: cursor ? 'progress' : undefined
  };
};

var createStyleCell = function createStyleCell(_ref) {
  var height = _ref.height,
      margin = _ref.margin,
      border = _ref.border,
      borderColor = _ref.borderColor,
      backgroundColor = _ref.backgroundColor,
      table = _ref.table;
  return {
    display: 'inline-block',
    backgroundColor: backgroundColor,
    width: margin !== 'auto' && margin ? "calc(100% / " + table.columns + " - " + 3 * margin + "px)" : "calc(100% / " + table.columns + " - 6px)",
    height: height,
    margin: margin != null ? margin : 2,
    border: border ? '1px solid' : undefined,
    borderColor: border && (borderColor != null ? borderColor : '#000')
  };
};

var createStyleAnimation = function createStyleAnimation(animationColor, animationDuration) {
  return {
    backgroundColor: animationColor != null ? animationColor : '#ddd',
    animationDuration: animationDuration ? animationDuration + "ms" : '3000ms'
  };
};

var Skeleton = function Skeleton(props) {
  var width = props.width,
      _props$height = props.height,
      height = _props$height === void 0 ? '1em' : _props$height,
      margin = props.margin,
      padding = props.padding,
      border = props.border,
      borderColor = props.borderColor,
      borderRadius = props.borderRadius,
      circle = props.circle,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? '#ccc' : _props$backgroundColo,
      color = props.color,
      cursor = props.cursor,
      placeholder = props.placeholder,
      placeholderPosition = props.placeholderPosition,
      animation = props.animation,
      animationColor = props.animationColor,
      animationDuration = props.animationDuration,
      _props$count = props.count,
      count = _props$count === void 0 ? 0 : _props$count,
      responsiveImage = props.responsiveImage,
      responsiveImageSSR = props.responsiveImageSSR,
      _props$table = props.table,
      table = _props$table === void 0 ? {
    rows: 0,
    columns: 0
  } : _props$table;

  var _useResponsiveImages = useResponsiveImages(responsiveImage, responsiveImageSSR),
      skeletonContainer = _useResponsiveImages.skeletonContainer,
      widthSkeletonContainer = _useResponsiveImages.widthSkeletonContainer,
      srcWidth = _useResponsiveImages.srcWidth,
      srcHeight = _useResponsiveImages.srcHeight;

  var definePositionPlaceholder = {
    left: 'flex-start',
    top: 'flex-start',
    center: 'center',
    right: 'flex-end',
    bottom: 'flex-end'
  };
  var justifyContent = placeholderPosition ? definePositionPlaceholder[placeholderPosition.horizontal] : undefined;
  var alignItems = placeholderPosition ? definePositionPlaceholder[placeholderPosition.vertical] : undefined;

  var createArray = function createArray(numberForArray) {
    return Array.from({
      length: numberForArray
    }, function (_, index) {
      return index;
    });
  };

  var wrappers = createArray(count);
  var tableRows = createArray(table.rows);
  var tableColumns = createArray(table.columns);
  var styleContainers = createStyleContainers({
    width: width,
    height: height,
    margin: margin,
    padding: padding,
    border: border,
    borderColor: borderColor,
    borderRadius: borderRadius,
    circle: circle,
    backgroundColor: backgroundColor,
    color: color,
    cursor: cursor,
    placeholderPosition: placeholderPosition,
    justifyContent: justifyContent,
    alignItems: alignItems,
    animation: animation,
    count: count,
    responsiveImage: responsiveImage,
    responsiveImageSSR: responsiveImageSSR,
    widthSkeletonContainer: widthSkeletonContainer,
    srcWidth: srcWidth,
    srcHeight: srcHeight
  });
  var styleTable = createStyleTable({
    width: width,
    cursor: cursor,
    animation: animation
  });
  var styleCell = createStyleCell({
    height: height,
    margin: margin,
    border: border,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    table: table
  });
  var styleAnimation = createStyleAnimation(animationColor, animationDuration);
  return React.createElement(SkeletonRender, {
    count: count,
    wrappers: wrappers,
    rows: table.rows,
    tableRows: tableRows,
    columns: table.columns,
    tableColumns: tableColumns,
    skeletonContainer: skeletonContainer,
    placeholder: placeholder,
    styleContainers: styleContainers,
    styleTable: styleTable,
    styleCell: styleCell,
    styleAnimation: styleAnimation,
    animation: animation
  });
};

export { Skeleton };
//# sourceMappingURL=skeleton.esm.js.map
